export default "__VITE_ASSET__megMNNaj__"